import React from "react";
import { ToastContainer, toast } from 'react-toastify';  
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import MultiSelectDropdown from '../admin_components/pages/customComponents/MultiSelectDropdown';
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import { config } from "../../constants";
import ConfirmationModal from "../ui/ConfirmationModal";
import apiClient from '../../utils/apiClient';
import CircleSign from "../ui/CircleSign";

const url = config.url.URL;
const UsersListLoadUrl = `${url}/UserMicroservice/ShareReportWith`;

export default class ReportModal extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        showShareModal: false,
        selectedRowIndex: "",
        fullscreen: false,
        showConfirmationModal:false,
        currentUsersSharedWith: [],
        errors: {},
        globalError: '',
      }

      this.ddlUsersSharedWith = React.createRef();
      this.ShareReportName = React.createRef();
      this.ShareReportType = React.createRef();
    }

    handleClose = () =>{
      this.setState({ showConfirmationModal: true })
  }

  doubleCloseModals = ()=> {
    this.setState({
      showShareModal: false,
      showConfirmationModal: false,
    });
  }

  closeConfirmationModal = ()=>{
    this.setState({ showConfirmationModal: false });
  }

    fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
    }

  openShareModal = (e) => {
    this.setState({ showShareModal: true });
    this.ShareReportName.current.value = e.row.data.name;
    this.ShareReportType.current.value = e.row.data.reportType;
    this.setState({ selectedRowIndex: e.row.data.reportId });
    apiClient.get(`${url}/ReportMicroservice/ReportSharedWith/${e.row.data.reportId}`)
      .then(response => {
        const data = response.data;
        this.ddlUsersSharedWith.current.state.idsSelected = data;
        this.ddlUsersSharedWith.current.setIds();
      });
  }

    openSettingsShareModal= (name, reportType, reportId) => {
        setTimeout(function() {
            this.setState({showShareModal:true});
            this.ShareReportName.current.value = name;
            this.ShareReportType.current.value = reportType;
            this.setState({selectedRowIndex: reportId});
            apiClient.get(`${url}/ReportMicroservice/ReportSharedWith/${reportId}`)
              .then(response => {
                const data = response.data;
                this.ddlUsersSharedWith.current.state.idsSelected = data;
                this.ddlUsersSharedWith.current.setIds();
            });
        }.bind(this), 50)
    }
    

    validateFields = () => {
      const errors = {};
      let hasErrors = false;
  
      const reportName = this.ShareReportName.current.value.trim();
      if (!reportName) {
        errors.reportName = 'The Report Name field is Required.';
        hasErrors = true;
      }  
      this.setState({ errors });  
      return !hasErrors;
    };

  onShareReport = () => {
    if (this.validateFields()) {
      let SelectedUsers = this.ddlUsersSharedWith.current.state.optionsSelected;
      let ReportId = this.state.selectedRowIndex;
      let ReportName = this.ShareReportName.current.value;

      let ReportShareInfo = {
        ReportId: ReportId,
        UserIds: SelectedUsers.map(u => u.value),
        ReportName: ReportName
      };

      apiClient.post(`${url}/ReportMicroservice/ShareReport`, ReportShareInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (ReportShareInfo.UserIds == "") {
              toast.success('Report saved successfully!');
            } else {
              toast.success('Report saved and shared successfully!');
            }
            this.doubleCloseModals();
            if (this.props.onSave && typeof this.props.onSave === "function") {
              this.props.onSave();
            }
          }
        });
    }
    else {
      this.setState({ globalError: 'Mandatory fields are missing. Saving of the Report form is not allowed.' });
    }
  }


render() {
  const { errors, globalError } = this.state;
    return (
      <>
        <Modal show={this.state.showShareModal} onHide={this.handleClose}  size="sl" centered fullscreen={this.state.fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title size="h6" >Save & Share Report</Modal.Title>
            <button
            type="button"
            class="btn btn-primary report-btn-2"
            onClick={this.fullscreenHandler}
            >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
          </Modal.Header>
          <Modal.Body>
            <Row>
            {globalError && (
              <div id='divTopMsg' className="mb-3 col-md-12" style={{ marginBottom: '5px' }}>
                <div style={{  border: 'solid 1px red', padding: '5px', display: 'grid' }}>
                  <label id="lblGlobalError" className="font-col-weight">{globalError}</label>
                </div>
              </div>
            )}
            </Row>            
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="Name">
                <Form.Label>Report Type</Form.Label>
                <Form.Control type="text" placeholder="Report Type" readOnly  enabled="false" ref={this.ShareReportType} />
                <br/>
                <Form.Label>Report Name</Form.Label> <CircleSign/>
                <Form.Control type="text" placeholder="Report Name" ref={this.ShareReportName}/>
                {errors.reportName && (
                <label id='lblReportNameReq' className="font-col-weight-11" style={{ marginTop: '5px'}}>The Report Name field is Required</label>
                )}
                <br/>
                <Form.Label>Share With</Form.Label>
                <MultiSelectDropdown 
                    loadUrl={UsersListLoadUrl} 
                    isMulti={true}
                    idsSelected={this.state.currentUsersSharedWith}
                    idColumnName='userId'
                    ref={this.ddlUsersSharedWith}
                  />
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
              Close
            </ButtonBootstrap>
            <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onShareReport}>
              Save
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>
        <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Are you sure you want to leave this page ?"/>
        </>
    );
}

}


